import { render, staticRenderFns } from "./infoTaskTab.vue?vue&type=template&id=5dafd386&scoped=true&"
import script from "./infoTaskTab.vue?vue&type=script&lang=js&"
export * from "./infoTaskTab.vue?vue&type=script&lang=js&"
import style0 from "./infoTaskTab.vue?vue&type=style&index=0&id=5dafd386&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dafd386",
  null
  
)

export default component.exports